// utils.js
export const printDocument = () => {
    window.print();
  };
  